// extracted by mini-css-extract-plugin
module.exports = {"videoModal":"player_videoModal__8Ul4n","videoPlayer":"player_videoPlayer__sEbBF","closeIcon":"player_closeIcon__6wqBs"};